import DataTableView from "@components/views/datatable-view";
import LoadingButton from "@components/ui-components/loading-button";
import UpsertLifecycle from "./upsert";
import useLifecycle from "./use-lifecycle";
import usePageChange from "@hooks/use-page-change";

const Lifecycle = () => {
    
    const {
        data: { lifecycle = [], pagination = {} },
        loading,
        columns,
        setQueryParams,
        handleModalConfig,
        modalConfig,
        getLifecycle
    } = useLifecycle();

    /* A custom hook that is used to handle the pagination. */
    const { handlePageChange, handlePerRowsChange } = usePageChange({
        setQueryParams
    });

    return (
        <>
            <DataTableView
                moduleName={"Life Cycle"}
                breadcrumbItems={{
                    items: [
                        {
                            title : "Life Cycle",
                            active: true
                        }
                    ]
                }}
                loading={loading}
                tableProps={{
                    data: lifecycle,
                    columns,
                    handlePageChange,
                    handlePerRowsChange,
                    pagination
                }}
                actionItems={
                    <LoadingButton
                        color="primary"
                        icon="plus"
                        onClick={() => handleModalConfig()}
                        subject="life-cycle"
                        text="Add life cycle"/>
                }/>
            <UpsertLifecycle
                getLifecycle={getLifecycle}
                modalConfig={modalConfig}
                handleModal={handleModalConfig}/>
        </>
    );
};

export default Lifecycle;
